import { __ } from '~/locale';

export const SQUASH_BEFORE_MERGE = {
  tooltipTitle: __('Required in this project.'),
  checkboxLabel: __('Squash commits'),
  helpLabel: __('What is squashing?'),
};

export const I18N_SHA_MISMATCH = {
  warningMessage: __('Merge blocked: new changes were just added.'),
  actionButtonLabel: __('Review changes'),
};
